<template>
  <v-modal-tab-trap>
    <transition
      name="fade-shrink-in"
      appear
    >
      <div
        v-show="open"
        class="background-on-top p-8"
        style="background-color: hsla(0, 0%, 0%, .5); cursor: default; z-index: 9999;"
        @click.self.prevent.stop="close"
      >
        <div
          ref="modal_content"
          class="modal-dialog modal-lg mt-8"
          role="document"
          tabindex="0"
        >
          <div
            class="modal-header"
          >
            <div class="bootstrap-dialog-header">
              <div class="bootstrap-dialog-title">
                <span class="header-text">{{ title }}</span>

                <span
                  :title="trans('core.close')"
                  class="material-icons pull-right"
                  style="cursor: pointer"
                  tabindex="0"
                  @click.stop.prevent="$emit('close')"
                  @keydown.enter.stop.prevent="$emit('close')"
                >close</span>
              </div>
            </div>
          </div>

          <div
            class="modal-content"
            :style="{ 'background-color': backgroundColor }"
          >
            <div
              class="modal-body"
            >
              <slot />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </v-modal-tab-trap>
</template>
<script>

// inspired by https://jsfiddle.net/xcoefffj/58/
// but without (portals)
import VModalTabTrap from './VModalTabTrap.vue'

export default {
  name: 'Modal',
  components: { VModalTabTrap },

  props: {
    open: {
      required: true,
    },
    title: {
      default: 'titel!',
    },
    backgroundColor: {
      required: false,
      default: 'white',
    },
  },
  data () {
    return {}
  },
  watch: {
    open (newValue) {
      if (newValue) {
        setTimeout(() => {
          this.$refs.modal_content.focus()
        }, 1)
      }
    },
  },
  created () {
    // listen to the escape key
    document.addEventListener('keydown', (e) => {
      if (this.open && e.keyCode == 27) {
        this.close()
      }
    })
  },
  methods: {
    close () {
      this.$emit('close')
    },
  },

}
</script>
<style scoped>

    .fade-shrink-in-enter-active,
    .fade-shrink-in-leave-active {
        transition: all .3s ease;
    }

    .fade-shrink-in-enter,
    .fade-shrink-in-leave-to {
        opacity: 0;
        transform: scale(1.1);
    }

    .modal-header {
        color: white;
        background-color: #25167a !important;
    }

    .header-text {
        display: inline-block;
        margin-top: 2px;
        width: 90%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .modal-body {
        padding-bottom: 10px;
        margin-left:2px;
        margin-right:2px;
        max-height: calc(100vh - 170px);
        overflow-y: auto;
    }

    .background-on-top {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 1026;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .mt-8 {
        margin-top: 8rem !important;
    }

    *, ::after, ::before {
        border-width: 0;
        border-style: solid;
        border-color: #dae1e7;
    }

    *, ::after, ::before {
        box-sizing: inherit;
    }

</style>
